import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { MoveFolderByIdRequest, MoveFolderByIdResponse } from "@maven-rest/docs/Folder.dto";
import { FolderUrl } from "@maven-rest/docs/Folder.url";

export function useMoveFolderMutation(
  pathVariable: Pick<MoveFolderByIdRequest, "folderId">,
  options?: SimpleMutationOptions<MoveFolderByIdResponse, MoveFolderByIdRequest>
) {
  return useBaseMutation({
    fnOption: {
      url: FolderUrl.moveFolderById(pathVariable.folderId),
    },
    ...options,
  });
}
